import { LocaleSetting, LocaleType } from 'src/renderer/types/config'

export const LOCALE: { [key: string]: LocaleType } = {
  ZH_CN: 'zh_CN',
  EN_US: 'en',
  NL_NL: 'nl',
  DE: 'de',
  ES: 'es',
  FR: 'fr',
  IT: 'it',
  ZH_HK: 'zh_HK',
}

export const localeSetting: LocaleSetting = {
  showPicker: true,
  // Locale
  locale: LOCALE.EN_US,
  // Default locale
  fallback: LOCALE.EN_US,
  // available Locales
  availableLocales: [LOCALE.ZH_CN, LOCALE.EN_US, LOCALE.NL_NL, LOCALE.DE, LOCALE.ES, LOCALE.FR, LOCALE.IT, LOCALE.ZH_HK]
}
